module.exports = __webpack_public_path__ + "static/media/Poppins-Bold.a3e0b5f4.ttf";